  
<template>
  <div class="hello">
    <!-- img tag를 이용한 일반적인 Image 생성. -->
    <div class="border border-light rounded mg-4-f">
        <div class="carousel">
            <viewer :images="this.image">
                <div class="d-lg-block align-items-end" :id="'tapeBox'+i" v-for="(form, i) in this.image" :key="form.id">
                    <div class="d-block image-sample-font pl-2">{{form.sampleId}}</div>
                    <img class="d-block"  :id="form.id" v-bind:src="'data:'+form.type.trim()+';base64,'+ form.img"/>
                </div>
            </viewer>
        </div>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
import common from '@/views/Common/common.js';
export default {
  name: 'TapeViewerConfirm',
  props: ['image'],
  data () {
    return {
      images: this.image
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped>
.gallary_image {
  width: 180px;
  height: 180px;
  display: inline;
  margin: 2px 2px;
  cursor: pointer;
}

.remove {
    position: relative;
    margin-left: 5px;
    bottom: 75px;
    left: 180px;
}
.remove i {
    font-size: 20px;
    color: #FF5722;
    opacity: 0.5;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/Common/image-upload/ViewerTapeConfirm.vue